import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import AppBar from '@material-ui/core/AppBar'
import Avatar from '@material-ui/core/Avatar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap'
import { BELOW_THE_HEADER, COLLAPSED_DRAWER, FIXED_DRAWER, HORIZONTAL_NAVIGATION, INSIDE_THE_HEADER } from 'constants/ActionTypes'
import { switchLanguage, toggleCollapsedNav } from 'actions/Setting'
import Menu from 'components/TopNav/Menu'
import UserInfoPopup from 'components/UserInfo/UserInfoPopup'
import Tooltip from '@material-ui/core/Tooltip'
import WifiLock from '@material-ui/icons/WifiLock'

class Header extends React.Component {
  state = {
    noInternetConnectionTooltipOpen: true
  }

  onAppNotificationSelect = () => {
    this.setState({
      appNotification: !this.state.appNotification
    })
  }
  onMailNotificationSelect = () => {
    this.setState({
      mailNotification: !this.state.mailNotification
    })
  }
  onLangSwitcherSelect = (event) => {
    this.setState({
      langSwitcher: !this.state.langSwitcher, anchorEl: event.currentTarget
    })
  }
  onSearchBoxSelect = () => {
    this.setState({
      searchBox: !this.state.searchBox
    })
  }
  onUserInfoSelect = () => {
    this.setState({
      userInfo: !this.state.userInfo
    })
  }
  handleRequestClose = () => {
    this.setState({
      langSwitcher: false,
      userInfo: false,
      mailNotification: false,
      appNotification: false,
      searchBox: false
    })
  }

  constructor () {
    super()
    this.state = {
      anchorEl: undefined,
      searchBox: false,
      searchText: '',
      mailNotification: false,
      userInfo: false,
      langSwitcher: false,
      appNotification: false
    }
  }

  onToggleCollapsedNav = (e) => {
    const val = !this.props.navCollapsed
    this.props.toggleCollapsedNav(val)
  }

  updateSearchText (evt) {
    this.setState({
      searchText: evt.target.value
    })
  }

  render () {
    const {drawerType, locale, navigationStyle, horizontalNavPosition, noConnection} = this.props
    const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'd-block d-xl-none' : drawerType.includes(COLLAPSED_DRAWER) ? 'd-block' : 'd-none'

    return (
      <AppBar
        className={`app-main-header ${(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) ? 'app-main-header-top' : ''}`}>
        <Toolbar className="app-toolbar" disableGutters={false}>
          {navigationStyle === HORIZONTAL_NAVIGATION ? <div className="d-block d-md-none pointer mr-3" onClick={this.onToggleCollapsedNav}>
                            <span className="jr-menu-icon">
                              <span className="menu-icon"/>
                            </span>
          </div>
            : <IconButton className={`jr-menu-icon mr-3 ${drawerStyle}`} aria-label="Menu"
                          onClick={this.onToggleCollapsedNav}>
              <span className="menu-icon"/>
            </IconButton>
          }

          <Link className="app-logo mr-2 d-none d-sm-block" to="/">
            <img src="https://via.placeholder.com/177x65" alt="Jambo" title="Jambo"/>
          </Link>


          {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === INSIDE_THE_HEADER) &&
          <Menu/>}

          <ul className="header-notifications list-inline ml-auto">
            {noConnection && <li className="list-inline-item mail-tour mr-3 d-inline-flex align-items-center">
              <Tooltip
                id="tooltip-controlled"
                title="No internet connection"
                onClose={() => {
                  this.setState({noInternetConnectionTooltipOpen: false})
                }}
                onOpen={() => {
                  this.setState({noInternetConnectionTooltipOpen: true})
                }}
                open={this.state.noInternetConnectionTooltipOpen}
                placement="bottom"
              >
                <WifiLock style={{width: 16, height: 16}}/>
              </Tooltip>
            </li>}
            {navigationStyle === HORIZONTAL_NAVIGATION &&
            <li className="list-inline-item user-nav">
              <Dropdown
                className="quick-menu"
                isOpen={this.state.userInfo}
                toggle={this.onUserInfoSelect.bind(this)}>

                <DropdownToggle
                  className="d-inline-block"
                  tag="span"
                  data-toggle="dropdown">
                  <IconButton className="icon-btn size-30">
                    <Avatar
                      alt='...'
                      src='https://via.placeholder.com/150x150'
                      className="size-30"
                    />
                  </IconButton>
                </DropdownToggle>

                <DropdownMenu right>
                  <UserInfoPopup/>
                </DropdownMenu>
              </Dropdown>
            </li>}
          </ul>
        </Toolbar>
      </AppBar>
    )
  }

}

const mapStateToProps = ({settings}) => {
  const {drawerType, locale, navigationStyle, horizontalNavPosition, noConnection} = settings
  return {drawerType, locale, navigationStyle, horizontalNavPosition, noConnection}
}

export default withRouter(connect(mapStateToProps, {toggleCollapsedNav, switchLanguage})(Header))


// WEBPACK FOOTER //
// ./components/Header/index.js